import { DatePickerField, Spinner } from '@prenuvo/halo-web';
import { Toaster, Typography } from '@prenuvo/halo-web';
import { Slots } from '@/components/ScanDates';
import { useScanDates } from '@/hooks';
import { disabledDates } from '@/utils/scanDates';
import { WHOLE_BODY_ENHANCED_SCREENING_SKU_ID } from '@/constants';
import { getFirstDateForEnhancedScreening } from '@/utils/sku370';

export default function ScanDates() {
  const {
    location,
    selectedDate,
    datePickerFieldProps,
    tzClosestAvailableDate,
    slots,
    isSlotsLoading,
    errorsScanDetails,
    sku,
    onDateChange,
    onMonthChange,
  } = useScanDates();

  const isErrors = Object.keys(errorsScanDetails).find(
    (key) => key === 'cannotProceedWithoutSelectingAScanDate',
  );

  return (
    <div>
      <div className="mb-8 flex flex-col justify-between gap-4 md:flex-row md:items-end">
        <div className="flex-grow">
          <h2 className="section-title">Date and Time</h2>
          {location ? (
            <p>
              Select the date and time of your scan for {location.address?.city}.
              <br />
              All times shown in {location.displayTimezone}.
            </p>
          ) : (
            <p>Select the date and time of your scan.</p>
          )}
        </div>
      </div>

      <div className="flex flex-col gap-4 md:mb-10 md:flex-row">
        <div className="md:basis-1/2">
          <span aria-live="assertive" className="sr-only" id="month-change-announcer"></span>
        <span aria-live="assertive" className="sr-only" id="month-change-announcer"></span>
          <DatePickerField
            value={selectedDate || new Date()}
            isDisabled={isSlotsLoading}
            data-testid="scan-date-picker"
            month={selectedDate || new Date() || tzClosestAvailableDate}
            onMonthChange={onMonthChange}
            onChange={onDateChange}
            disabled={(match: Date) =>
              disabledDates({
                match,
                tzClosestAvailableDate:
                  Number(sku?.skuID) === WHOLE_BODY_ENHANCED_SCREENING_SKU_ID
                    ? (getFirstDateForEnhancedScreening(location?.code!) as any)
                    : tzClosestAvailableDate,
                slotsData: slots,
                skuId: Number(sku?.skuID),
                locationId: location?.code,
              })
            }
            name="scanDate"
            label={{
              children: 'Select date',
            }}
            showOutsideDays={false}
            hasFooter={false}
            className={{
              root: '[&_tr]:flex [&_tr]:justify-between',
            }}
            {...datePickerFieldProps}
          />
        </div>

        <div
          className={`overflow-auto md:basis-1/2 ${isSlotsLoading ? 'flex items-center justify-center' : ''}`}
        >
          <div className={`mb-10 ${isErrors ? 'flex flex-col gap-5' : ''}`}>
            {!isSlotsLoading ? (
              <Slots />
            ) : (
              <div>
                <Spinner
                  title={{
                    children: 'Loading available slots',
                  }}
                />
              </div>
            )}
            <div data-testid="slot-error">
              {isErrors && (
                <Toaster>
                  <Typography
                    as="p"
                    variant="paragraph-sm"
                    className="pb-3 text-center font-semibold text-red-500"
                  >
                    Please select a time slot to proceed
                  </Typography>
                </Toaster>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
